import React, { createContext, useState, useContext, useEffect } from 'react';
import { MyContext } from './ProviderContext';

export const Project = () => {

    const { menuComponent, setMenuComponent } = useContext(MyContext);

    useEffect(() => {
        setMenuComponent({ home: '', about: '', services: '', team: '', contact: '', project: 'active' });
    }, [])

    return (

        <>
            <div className="page-header">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <h2>Our Projects</h2>
                        </div>
                        <div className="col-12">
                            <a href="">Home</a>
                            <a href="">Our Projects</a>
                        </div>
                    </div>
                </div>
            </div>

            <div className="portfolio">
                <div className="container">
                    <div className="section-header text-center">
                        <p>Our Projects</p>
                        <h2>See Some Of Our Projects</h2>
                    </div>

                    <div className="row portfolio-container">
                        <div className="col-lg-4 col-md-6 col-sm-12 portfolio-item first wow fadeInUp" data-wow-delay="0.1s">
                            <div className="portfolio-warp">
                                <div className="portfolio-img">
                                    <img src="img/project/water-manifold.png" alt="Image" />
                                    <div className="portfolio-overlay">
                                        <p>
                                            Construction and Installation of Water Manifold and Hydrant Lines for Drilling Rig Activities at Obiafu South-West Deep D Locatio

                                        </p>
                                    </div>
                                </div>
                                <div className="portfolio-text">
                                    <h3 title="Installation of Water Manifold">Installation of Water Manifold</h3>
                                    <a className="btn" href="img/project/water-manifold.png" data-lightbox="portfolio">+</a>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12 portfolio-item second wow fadeInUp" data-wow-delay="0.2s">
                            <div className="portfolio-warp">
                                <div className="portfolio-img">
                                    <img src="img/project/flowstation-upgrade.png" alt="Image" />
                                    <div className="portfolio-overlay">
                                        <p>
                                            Irri Flow Station Facility Upgrade and Maintenance

                                        </p>
                                    </div>
                                </div>
                                <div className="portfolio-text">
                                    <h3>Facility Upgrade</h3>
                                    <a className="btn" href="img/project/flowstation-upgrade.png" data-lightbox="portfolio">+</a>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12 portfolio-item third wow fadeInUp" data-wow-delay="0.3s">
                            <div className="portfolio-warp">
                                <div className="portfolio-img">
                                    <img src="img/project/construction-asphalt-road.png" alt="Image" />
                                    <div className="portfolio-overlay">
                                        <p>
                                            Construction of 1.5km Asphalt Road and Drainage at Aggah, ONELGA, Rivers State

                                        </p>
                                    </div>
                                </div>
                                <div className="portfolio-text">
                                    <h3 title="Construction of 1.5km Asphalt Road">Construction of 1.5km Asphalt Road</h3>
                                    <a className="btn" href="img/project/construction-asphalt-road.png" data-lightbox="portfolio">+</a>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12 portfolio-item first wow fadeInUp" data-wow-delay="0.4s">
                            <div className="portfolio-warp">
                                <div className="portfolio-img">
                                    <img src="img/project/pipeline-repair.png" alt="Image" />
                                    <div className="portfolio-overlay">
                                        <p>
                                            Pipeline Repairs & Associated Jobs at KP+22 and Sectional Replacement of Ob/Ob-IEFCL 18” Gas Pipeline at ROW Chainage KP 17.8 Near Awarra

                                        </p>
                                    </div>
                                </div>
                                <div className="portfolio-text">
                                    <h3>Pipeline Repairs</h3>
                                    <a className="btn" href="img/project/pipeline-repair.png" data-lightbox="portfolio">+</a>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12 portfolio-item second wow fadeInUp" data-wow-delay="0.5s">
                            <div className="portfolio-warp">
                                <div className="portfolio-img">
                                    <img src="img/project/repair-of-deep-life-link.png" alt="Image" />
                                    <div className="portfolio-overlay">
                                        <p>
                                            Emergency Repairs of Failed & Unmororable Sections of Deeper Life Link Road to Miniukwu Street, Mgbuoshimini, Rumueme, Rivers State

                                        </p>
                                    </div>
                                </div>
                                <div className="portfolio-text">
                                    <h3>Emergency Repairs</h3>
                                    <a className="btn" href="img/project/repair-of-deep-life-link.png" data-lightbox="portfolio">+</a>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12 portfolio-item third wow fadeInUp" data-wow-delay="0.6s">
                            <div className="portfolio-warp">
                                <div className="portfolio-img">
                                    <img src="img/project/flowline-construction.png" alt="Image" />
                                    <div className="portfolio-overlay">
                                        <p>
                                            Flowline Construction & Flowline Sectional Replacement Works in NAOC Land Area

                                        </p>
                                    </div>
                                </div>
                                <div className="portfolio-text">
                                    <h3>Flowline Construction</h3>
                                    <a className="btn" href="img/project/flowline-construction.png" data-lightbox="portfolio">+</a>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12 portfolio-item third wow fadeInUp" data-wow-delay="0.6s">
                            <div className="portfolio-warp">
                                <div className="portfolio-img">
                                    <img src="img/project/flowline-sectional-replacement.png" alt="Image" />
                                    <div className="portfolio-overlay">
                                        <p>
                                            Flowline Construction & Flowlie Sectional Replacement Works in NAOC Land Area

                                        </p>
                                    </div>
                                </div>
                                <div className="portfolio-text">
                                    <h3>Flowline Construction</h3>
                                    <a className="btn" href="img/project/flowline-sectional-replacement.png" data-lightbox="portfolio">+</a>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12 portfolio-item third wow fadeInUp" data-wow-delay="0.6s">
                            <div className="portfolio-warp">
                                <div className="portfolio-img">
                                    <img src="img/project/sand-dredging.png" alt="Image" />
                                    <div className="portfolio-overlay">
                                        <p>
                                            Sand Dredging and Stockpiling for Construction of Enwhe West Location/ Access Bridge and Byepass

                                        </p>
                                    </div>
                                </div>
                                <div className="portfolio-text">
                                    <h3>Sand Dredging and Stockpiling</h3>
                                    <a className="btn" href="img/project/sand-dredging.png" data-lightbox="portfolio">+</a>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12 portfolio-item third wow fadeInUp" data-wow-delay="0.6s">
                            <div className="portfolio-warp">
                                <div className="portfolio-img">
                                    <img src="img/project/stock-piling.png" alt="Image" />
                                    <div className="portfolio-overlay">
                                        <p>
                                            Sand Dredging and Stockpiling for Construction of Enwhe West Location/ Access Bridge and Byepass

                                        </p>
                                    </div>
                                </div>
                                <div className="portfolio-text">
                                    <h3>Sand Dredging and Stockpiling</h3>
                                    <a className="btn" href="img/project/stock-piling.png" data-lightbox="portfolio">+</a>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12 portfolio-item third wow fadeInUp" data-wow-delay="0.6s">
                            <div className="portfolio-warp">
                                <div className="portfolio-img">
                                    <img src="img/project/remodeling.png" alt="Image" />
                                    <div className="portfolio-overlay">
                                        <p>
                                            Remodeling and Rehabilitation of the Maritime Administrative Office

                                        </p>
                                    </div>
                                </div>
                                <div className="portfolio-text">
                                    <h3>Remodeling and Rehabilitation</h3>
                                    <a className="btn" href="img/project/remodeling.png" data-lightbox="portfolio">+</a>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12 portfolio-item third wow fadeInUp" data-wow-delay="0.6s">
                            <div className="portfolio-warp">
                                <div className="portfolio-img">
                                    <img src="img/project/land-reclamation.png" alt="Image" />
                                    <div className="portfolio-overlay">
                                        <p>
                                            Land Reclamation and Building of Frantino Group CEO’s Residential Complex in Port Harcourt, Rivers Stat

                                        </p>
                                    </div>
                                </div>
                                <div className="portfolio-text">
                                    <h3>Land Reclamation and Building </h3>
                                    <a className="btn" href="img/project/land-reclamation.png" data-lightbox="portfolio">+</a>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12 portfolio-item third wow fadeInUp" data-wow-delay="0.6s">
                            <div className="portfolio-warp">
                                <div className="portfolio-img">
                                    <img src="img/project/clearing.png" alt="Image" />
                                    <div className="portfolio-overlay">
                                        <p>
                                            Clearing and Desilting of Asut Oyet Creek in Ngo, Andoni LGA, Rivers State (Lot 3)

                                        </p>
                                    </div>
                                </div>
                                <div className="portfolio-text">
                                    <h3>Clearing and Desilting </h3>
                                    <a className="btn" href="img/project/clearing.png" data-lightbox="portfolio">+</a>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12 portfolio-item third wow fadeInUp" data-wow-delay="0.6s">
                            <div className="portfolio-warp">
                                <div className="portfolio-img">
                                    <img src="img/project/supply-of-materials.png" alt="Image" />
                                    <div className="portfolio-overlay">
                                        <p>
                                            Supply of Materials/ Services and Emergency Intervention Works in Obrikom 6

                                        </p>
                                    </div>
                                </div>
                                <div className="portfolio-text">
                                    <h3>Supply of Materials/ Services  </h3>
                                    <a className="btn" href="img/project/supply-of-materials.png" data-lightbox="portfolio">+</a>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12 portfolio-item third wow fadeInUp" data-wow-delay="0.6s">
                            <div className="portfolio-warp">
                                <div className="portfolio-img">
                                    <img src="img/project/supply-of-materials-2.png" alt="Image" />
                                    <div className="portfolio-overlay">
                                        <p>
                                            Supply of Materials/ Services and Emergency Intervention Works in Obrikom 6

                                        </p>
                                    </div>
                                </div>
                                <div className="portfolio-text">
                                    <h3>Supply of Materials/ Services  </h3>
                                    <a className="btn" href="img/project/supply-of-materials-2.png" data-lightbox="portfolio">+</a>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12 portfolio-item third wow fadeInUp" data-wow-delay="0.6s">
                            <div className="portfolio-warp">
                                <div className="portfolio-img">
                                    <img src="img/project/clearing-2.png" alt="Image" />
                                    <div className="portfolio-overlay">
                                        <p>
                                            Clearing and Desilting of Lobia 1 Creek in Southern Ijaw LGA, Bayelsa State

                                        </p>
                                    </div>
                                </div>
                                <div className="portfolio-text">
                                    <h3>Clearing and Desilting  </h3>
                                    <a className="btn" href="img/project/clearing-2.png" data-lightbox="portfolio">+</a>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12 portfolio-item third wow fadeInUp" data-wow-delay="0.6s">
                            <div className="portfolio-warp">
                                <div className="portfolio-img">
                                    <img src="img/project/perimeter-fencing.png" alt="Image" />
                                    <div className="portfolio-overlay">
                                        <p>
                                            Construction of Citadel Perimeter Fencing of Obrikom 15 Mini -Manifold

                                        </p>
                                    </div>
                                </div>
                                <div className="portfolio-text">
                                    <h3 title="Construction of Citadel Perimeter Fencing">Construction of Citadel Perimeter Fencing  </h3>
                                    <a className="btn" href="img/project/perimeter-fencing.png" data-lightbox="portfolio">+</a>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>
            </div>

        </>
    )
}